import React from "react";

const AIPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-bold text-[#e64a32] text-center">AI Policy for PASSIONIT PRUTL GAMES</h1>
      <p className="mt-4">
        <strong>AI Usage:</strong> PASSIONIT PRUTL GAMES utilizes AI responses from third-party Large Language Models (LLMs) via API integrations. PASSION INFOTECH PVT LTD, PCOMBINATOR, PROSPERO, or any other sister concerns are not responsible for the accuracy, relevance, or impact of AI-generated responses.
      </p>
      <p className="mt-2">
        <strong>User Responsibility:</strong> All AI responses are for personal reflection and should be interpreted at the user's own risk. The game’s scoring system is a learning aid and does not evaluate or undermine an individual’s knowledge, skills, or education.
      </p>
      <p className="mt-2">
        <strong>Data Privacy:</strong> User responses are recorded securely and are accessible only to the user. Data may be disclosed only if required by legal authorities or used internally to improve product functionality and AI performance.
      </p>
      <p className="mt-2">
        <strong>Ethical Use:</strong> This game does not support or promote gambling. Its purpose is to encourage personal growth and focus on soulful development.
      </p>
      <p className="mt-2">
        <strong>Transparency:</strong> PASSIONIT PRUTL GAMES ensures fairness and transparency. We declare that we do not own or manipulate LLM outputs and rely solely on external AI APIs.
      </p>
      <p className="mt-4 text-center">
        <a href="/" className="text-[#e64a32] hover:underline">Back to Home</a>
      </p>
    </div>
  );
};

export default AIPolicy;
